import React from "react";

export default function ActionButton({ onClick, disabled, glowing, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`px-6 py-2.5 rounded-full font-semibold text-sm tracking-wide transition
        ${
          disabled
            ? "bg-zinc-800 text-zinc-500 cursor-not-allowed"
            : glowing
              ? "bg-emerald-400 text-zinc-950 shadow-lg shadow-emerald-500/60 ring-2 ring-emerald-400/40 hover:bg-emerald-300 active:scale-[0.98]"
              : "bg-emerald-500 text-zinc-950 shadow-md shadow-emerald-500/20 hover:bg-emerald-400 active:scale-[0.98]"
        }`}
    >
      {label}
    </button>
  );
}
